import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function Hero() {
  return (
    <div className="relative h-[80vh] flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1594938298603-c8148c4dae35?q=80&w=2000&auto=format&fit=crop")',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
        }}
      >
        <div className="absolute inset-0 bg-black/60"></div>
      </div>

      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
        <motion.h1 
          className="text-4xl md:text-6xl font-serif text-white leading-tight mb-6"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          Tatvam – Premium Suiting & Shirting Retail & Custom Tailoring
        </motion.h1>
        
        <motion.p 
          className="text-lg md:text-xl text-gray-200 font-light mb-10 tracking-wide"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          Finest fabrics from global brands. Tailored to perfection.
        </motion.p>
        
        <motion.div 
          className="flex flex-col sm:flex-row gap-4 justify-center"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.6 }}
        >
          <Link 
            to="/contact" 
            className="bg-[#d4af37] text-black px-8 py-4 text-sm uppercase tracking-widest font-bold hover:bg-white transition-all duration-300"
          >
            Book Appointment
          </Link>
          <Link 
            to="/contact" 
            className="border border-white text-white px-8 py-4 text-sm uppercase tracking-widest font-bold hover:bg-white hover:text-black transition-all duration-300"
          >
            Visit Store
          </Link>
        </motion.div>
      </div>
    </div>
  );
}